import { connect } from 'react-redux';
import { compose, hoistStatics, withProps } from 'recompose';
import { translate } from 'react-i18next';
import Favicon from './Favicon';
import ProfileService from '../../../services/profile.service';

const mapStateToProps = state => ({
  subscriber: state.settings.subscriber,
});

const enhance = compose(
  connect(mapStateToProps),
  translate('portal'),
  withProps(props => ({
    favSrc: props.subscriber.white_label && props.subscriber && props.subscriber.favicon_filename &&
      ProfileService.getLogo(props.subscriber.favicon_filename, null, 16, 16, true),
  })),
);

export default hoistStatics(enhance)(Favicon);



// WEBPACK FOOTER //
// ./src/containers/layout/favicon/index.js